module.exports = __webpack_public_path__ + "img/in-progress-semipublic.18bb9d03.png";